import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      // 'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
      'Access-Control-Allow-Headers': '*',
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa(environment.username+ ':' +environment.password)
    }
  )
};

@Injectable({
  providedIn: 'root'
})
export class WebapiService {
  baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  /* Uses http.post() to submit data from a single API endpoint */
  postMethod(endpointUrl: string, data: any): Observable<any> {
    const apiUrl = this.baseUrl + endpointUrl;
    return this.http.post(
      apiUrl, data,
      httpOptions
    );
  }

  /* Uses http.patch() to submit data from a single API endpoint */
  patchMethod(endpointUrl: string, data: any): Observable<any> {
    const apiUrl = this.baseUrl + endpointUrl;
    return this.http.patch(
      apiUrl, data,
      httpOptions
    );
  }

  /* Uses http.post() to submit data from a single API endpoint this method is to get a blob response
     like estimate excel download*/
  postMethodForBlob(endpointUrl: string, data?: any): Observable<any> {
    const apiUrl = this.baseUrl + endpointUrl;

    return this.http.post(
      apiUrl, data,
      { headers: httpOptions.headers, responseType: 'arraybuffer', observe: 'response' },

    );
  }

  /* Uses http.get() to submit data from a single API endpoint this method is to get a blob response
     like estimate excel download*/
  getMethodForBlob(endpointUrl: string): Observable<any> {
    const apiUrl = this.baseUrl + endpointUrl;

    return this.http.get(apiUrl, { headers: httpOptions.headers, responseType: 'arraybuffer', observe: 'response' }

    );
  }
  /* Uses http.get() to load all data from a single API endpoint */
  getMethod(endPoint: string): Observable<any> {
    const apiUrl = this.baseUrl + endPoint;
    return this.http.get(apiUrl, httpOptions);
  }

  /* Uses http.put() to update data from a single API endpoint */
  update(endPoint: string, data: any) {
    const apiUrl = this.baseUrl + endPoint;
    return this.http.put(apiUrl, data);
  }

  /* Uses http.delete() to delete data from a single API endpoint */
  delete(endPoint: string): Observable<any> {
    const apiUrl = this.baseUrl + endPoint;
    return this.http.delete(apiUrl, httpOptions);
  }

  /* Uses http.post() to post the form data along with file */
  postFormData(endpointUrl: string, data: any): Observable<any> {
    const apiUrl = this.baseUrl + endpointUrl;
    return this.http.post(
      apiUrl, data,
    );
  }

}


